import { useEffect, useState } from 'react';
import { clienteService, prestamoService } from '../../services/api';
import '../../styles/Reportes.css';

const HistorialPrestamos = () => {
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState('');
  const [clienteId, setClienteId] = useState('');
  const [prestamos, setPrestamos] = useState([]);
  const [cliente, setCliente] = useState(null);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    cargarClientes();
  }, []);

  const cargarClientes = async () => {
    try {
      const response = await clienteService.getAll();
      setClientes(response.data.clientes || []);
    } catch (error) {
      console.error('Error al cargar clientes:', error);
    }
  };

  const buscarPorCliente = async () => {
    if (!clienteSeleccionado) {
      alert('Por favor selecciona un cliente');
      return;
    }

    setCargando(true);
    try {
      const [prestamosRes, clienteRes] = await Promise.all([
        prestamoService.getAll({ cliente_id: clienteSeleccionado }),
        clienteService.getById(clienteSeleccionado)
      ]);

      setPrestamos(prestamosRes.data.prestamos || []);
      setCliente(clienteRes.data);
    } catch (error) {
      alert('Error al cargar el historial');
      console.error(error);
    } finally {
      setCargando(false);
    }
  };

  const buscarPorId = async () => {
    if (!clienteId) {
      alert('Por favor ingresa un ID de cliente');
      return;
    }

    setCargando(true);
    try {
      const [prestamosRes, clienteRes] = await Promise.all([
        prestamoService.getAll({ cliente_id: clienteId }),
        clienteService.getById(clienteId)
      ]);

      setPrestamos(prestamosRes.data.prestamos || []);
      setCliente(clienteRes.data);
    } catch (error) {
      alert('Error al cargar el historial');
      console.error(error);
    } finally {
      setCargando(false);
    }
  };

  const formatearFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-DO');
  };

  const calcularTotales = () => {
    const totalPrestado = prestamos.reduce((sum, p) => sum + p.monto_prestado, 0);
    const totalCapital = prestamos.reduce((sum, p) => sum + p.capital, 0);
    const totalInteres = prestamos.reduce((sum, p) => sum + p.interes, 0);
    const totalGeneral = prestamos.reduce((sum, p) => sum + p.total, 0);

    return { totalPrestado, totalCapital, totalInteres, totalGeneral };
  };

  const contarPorEstado = () => {
    const activos = prestamos.filter(p => p.estado === 'activo').length;
    const pagados = prestamos.filter(p => p.estado === 'pagado').length;
    const vencidos = prestamos.filter(p => p.estado === 'vencido').length;

    return { activos, pagados, vencidos };
  };

  const totales = calcularTotales();
  const estados = contarPorEstado();

  return (
    <div className="reporte-detalle">
      <div className="reporte-header">
        <h1>📋 Historial de Préstamos</h1>
        <p>Consulta el historial completo de préstamos por cliente</p>
      </div>

      <div className="filtros-container">
        <div className="filtro-grupo">
          <label>Cliente:</label>
          <select
            value={clienteSeleccionado}
            onChange={(e) => setClienteSeleccionado(e.target.value)}
            className="input-select"
          >
            <option value="">--- Seleccione ---</option>
            {clientes.map(cli => (
              <option key={cli.id} value={cli.id}>
                {cli.cedula} - {cli.nombres} {cli.apellidos}
              </option>
            ))}
          </select>
          <button onClick={buscarPorCliente} className="btn-buscar">
            Buscar
          </button>
        </div>

        <div className="separador">O</div>

        <div className="filtro-grupo">
          <label>Cliente ID:</label>
          <input
            type="number"
            value={clienteId}
            onChange={(e) => setClienteId(e.target.value)}
            placeholder="ID del cliente"
            className="input-text"
          />
          <button onClick={buscarPorId} className="btn-buscar">
            Buscar
          </button>
        </div>
      </div>

      {cliente && (
        <div className="info-prestamo">
          <h3>Información del Cliente</h3>
          <div className="info-grid">
            <div><strong>Nombre:</strong> {cliente.nombres} {cliente.apellidos}</div>
            <div><strong>Cédula:</strong> {cliente.cedula}</div>
            <div><strong>Teléfono:</strong> {cliente.celular}</div>
            <div><strong>Dirección:</strong> {cliente.direccion}</div>
            <div><strong>Total Préstamos:</strong> {prestamos.length}</div>
            <div><strong>Activos:</strong> <span className="badge activo">{estados.activos}</span></div>
          </div>
        </div>
      )}

      {cargando && (
        <div className="loading">Cargando datos...</div>
      )}

      {!cargando && prestamos.length > 0 && (
        <>
          <div className="tabla-container">
            <table className="tabla-reporte">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Monto</th>
                  <th>Capital</th>
                  <th>Interés</th>
                  <th>Tasa</th>
                  <th>Modalidad</th>
                  <th>Fecha</th>
                  <th>Efectividad</th>
                  <th>Estatus</th>
                </tr>
              </thead>
              <tbody>
                {prestamos.map(prestamo => (
                  <tr key={prestamo.id}>
                    <td>{prestamo.id}</td>
                    <td className="destacado">${prestamo.monto_prestado?.toFixed(2)}</td>
                    <td>${prestamo.capital?.toFixed(2)}</td>
                    <td>${prestamo.interes?.toFixed(2)}</td>
                    <td>{prestamo.tasa}%</td>
                    <td>{prestamo.modalidad}</td>
                    <td>{formatearFecha(prestamo.fecha_inicio)}</td>
                    <td>{formatearFecha(prestamo.fecha_efectividad)}</td>
                    <td><span className={`badge ${prestamo.estado}`}>{prestamo.estado}</span></td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="totales">
                  <td><strong>TOTALES</strong></td>
                  <td className="destacado"><strong>${totales.totalPrestado.toFixed(2)}</strong></td>
                  <td><strong>${totales.totalCapital.toFixed(2)}</strong></td>
                  <td><strong>${totales.totalInteres.toFixed(2)}</strong></td>
                  <td colSpan="5"></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="resumen-cards">
            <div className="card-resumen">
              <div className="card-icono">📊</div>
              <div className="card-info">
                <div className="card-valor">{prestamos.length}</div>
                <div className="card-label">Total Préstamos</div>
              </div>
            </div>
            <div className="card-resumen">
              <div className="card-icono">✅</div>
              <div className="card-info">
                <div className="card-valor">{estados.activos}</div>
                <div className="card-label">Activos</div>
              </div>
            </div>
            <div className="card-resumen">
              <div className="card-icono">💰</div>
              <div className="card-info">
                <div className="card-valor">{estados.pagados}</div>
                <div className="card-label">Pagados</div>
              </div>
            </div>
            <div className="card-resumen">
              <div className="card-icono">💵</div>
              <div className="card-info">
                <div className="card-valor">${totales.totalGeneral.toFixed(2)}</div>
                <div className="card-label">Total General</div>
              </div>
            </div>
          </div>
        </>
      )}

      {!cargando && prestamos.length === 0 && (clienteSeleccionado || clienteId) && (
        <div className="sin-datos">
          <p>No se encontraron préstamos para este cliente</p>
        </div>
      )}
    </div>
  );
};

export default HistorialPrestamos;
